import { Button } from "@mui/material";

import { useSnackbar } from "notistack";

import { useCloneProject } from "hooks/studyAreaHooks";
import { useTranslation } from "react-i18next";

interface Props {
  uuid: string;
}

export function CloneProject(props: Props) {
  const { uuid } = props;
  const { t } = useTranslation();
  const { mutateAsync } = useCloneProject();
  const { enqueueSnackbar } = useSnackbar();

  async function duplicateProject() {
    mutateAsync(uuid, {
      onSuccess: (data) => {
        enqueueSnackbar(t("label.projectCloned"), {
          variant: "success",
        });
        window.open(`/${data.uuid}/measures`);
      },
      onError: (errors) => {
        enqueueSnackbar(t("label.somethingWentWrong"), {
          variant: "error",
        });
    },
    });
  }

  return (
    <Button onClick={duplicateProject} variant="green-outlined">
      {t("label.cloneProject")}
    </Button>
  );
}
